/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Gallery_Photo_NInputs */

const cs_gallery_photo_n = /** @type {(inputs: Gallery_Photo_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Foto ${i?.n}`)
};

const en_gallery_photo_n = /** @type {(inputs: Gallery_Photo_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Photo ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Photo {n}" |
*
* @param {Gallery_Photo_NInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_photo_n = /** @type {((inputs: Gallery_Photo_NInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Photo_NInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_photo_n(inputs)
	return cs_gallery_photo_n(inputs)
});